document.addEventListener('DOMContentLoaded', function () {
    let baseUrl = '/api/news?page=';
    let currentPage = 1;
    let last;

    function paginNews(page) {
        const url = baseUrl + page;

        fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        })
            .then(response => response.json())
            .then(data => {
                clearNewsontent();
                console.log(data)
                updateNews(data);
                currentPage = page;
                last = data.meta.last_page;
                if (data.meta.last_page > 1) {
                    createPaginationButtons(data.meta.last_page);
                } else {
                    let container = document.getElementById('see-more-container');
                    container.remove();
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    paginNews(currentPage);

    function createPaginationButtons(totalPages) {
        const buttonContainer = document.getElementById('see-more-container');

        buttonContainer.innerHTML = '';

        for (let i = 1; i <= totalPages; i++) {
            const button = document.createElement('button');
            button.textContent = i;
            if (i === currentPage) {
                button.classList.add('active-btn');
            }
            (function (pageNumber) {
                button.addEventListener('click', function () {
                    paginNews(pageNumber);
                });
            })(i);

            buttonContainer.appendChild(button);
        }
    }

    function clearNewsontent() {
        const newsContainer = document.querySelector('.news-wrapper__content');
        if (newsContainer) {
            newsContainer.innerHTML = '';
        }
    }

    function updateNews(data) {
        const newsContainer = document.querySelector('.news-wrapper__content');
        if (newsContainer && data.data) {
            data.data.forEach(item => {
                const itemElement = document.createElement('a');
                itemElement.classList.add('news-item');
                itemElement.setAttribute('href', `/news/${item.slug}`);

                const publishDate = new Date(item.publish_date);

                itemElement.innerHTML = `
                  <div class="img-wrapper">
                            <img src="${item.image}" alt="news-img">
                        </div>
                        <div class="news-text">
                            <div class="news-text__date">
                                ${publishDate.toLocaleDateString('uk-UA', {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric'
                })}
                            </div>
                            <h3 class="news-text__title">
                                ${item.title}
                            </h3>
                            <p class="news-text__desc">
                               ${item.short_description}
                            </p>
                        </div>
            `;
                newsContainer.appendChild(itemElement);
            });
        }
    }

    const prev = document.getElementById('prevPageButton');
    prev.addEventListener('click', function () {
        PrevPage();
    });

    const next = document.getElementById('nextPageButton');
    next.addEventListener('click', function () {
        NextPage();
    });

    function PrevPage() {
        if (currentPage > 1) {
            currentPage--;
            paginNews(currentPage);
        }
    }

    function NextPage() {
        if (currentPage < last) {
            currentPage++;
            paginNews(currentPage);
        }
    }
});
